var _g, _rect, _rect2, _path, _circle, _circle2, _circle3, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _circle4, _path0, _path1, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmptyState(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1003,
    height: 387,
    className: "empty-state-icon",
    viewBox: "0 0 1103 387",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1096_567)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 348.74,
    y: 120.363,
    width: 407.368,
    height: 222.201,
    rx: 11.11,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 349.203,
    y: 120.826,
    width: 406.443,
    height: 221.275,
    rx: 10.6471,
    stroke: "#EBEDF5",
    strokeWidth: 0.925837
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 472.803,
    y: 283.311,
    width: 161.096,
    height: 5.55502,
    rx: 2.77751,
    fill: "#E4E6EF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 454.285,
    y: 268.498,
    width: 196.278,
    height: 5.55502,
    rx: 2.77751,
    fill: "#E4E6EF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M348.74 131.473C348.74 125.337 353.714 120.363 359.85 120.363H744.999C751.135 120.363 756.109 125.337 756.109 131.473V142.583H348.74V131.473Z",
    fill: "#E4E6EF"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 743.148,
    cy: 131.469,
    r: 3.70335,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 732.039,
    cy: 131.469,
    r: 3.70335,
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 720.928,
    cy: 131.469,
    r: 3.70335,
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M284.359 112.677C284.199 112.677 284.042 112.624 283.913 112.522L265.689 98.1021C265.466 97.9252 265.368 97.6335 265.439 97.3577C265.51 97.0823 265.737 96.8746 266.018 96.8281L347.904 83.3375C348.259 83.2795 348.608 83.4948 348.711 83.8428C348.814 84.1906 348.642 84.5606 348.31 84.7061L284.648 112.617C284.555 112.657 284.457 112.677 284.359 112.677ZM267.857 97.9832L284.466 111.125L342.489 85.6874L267.857 97.9832Z",
    fill: "#E4E6EF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M267.857 97.9832L284.466 111.125L342.489 85.6874L267.857 97.9832Z",
    fill: "#E4E6EF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M321.203 141.833C321.043 141.833 320.885 141.779 320.757 141.678L297.565 123.334C297.392 123.197 297.291 122.987 297.292 122.766C297.293 122.545 297.396 122.337 297.571 122.201L347.58 83.4857C347.843 83.2834 348.21 83.2862 348.47 83.4932C348.729 83.7011 348.812 84.0598 348.671 84.3604L321.854 141.42C321.761 141.619 321.582 141.764 321.368 141.814C321.313 141.827 321.258 141.833 321.203 141.833ZM299.178 122.776L320.938 139.987L346.099 86.4512L299.178 122.776Z",
    fill: "#E4E6EF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M299.178 122.776L320.938 139.987L346.099 86.4512L299.178 122.776Z",
    fill: "#E4E6EF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M283.737 139.939C283.652 139.939 283.565 139.924 283.483 139.893C283.201 139.786 283.015 139.515 283.018 139.214L283.254 112.133C283.256 111.85 283.425 111.594 283.684 111.481L347.73 83.3885C348.065 83.2434 348.452 83.3675 348.638 83.6802C348.823 83.992 348.747 84.3938 348.459 84.6162L298.502 123.285L284.28 139.691C284.141 139.852 283.941 139.939 283.737 139.939ZM284.688 112.611L284.473 137.273L297.462 122.289C297.493 122.253 297.528 122.22 297.565 122.191L342.966 87.0491L284.688 112.611Z",
    fill: "#D7D9E6"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M284.688 112.611L284.473 137.273L297.462 122.289C297.493 122.253 297.528 122.22 297.565 122.191L342.966 87.0491L284.688 112.611Z",
    fill: "#D7D9E6"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M280.226 141.651C243.501 159.86 219.85 190.721 396.885 190.721C688.524 190.721 937.106 249.756 768.143 312.005C750.552 318.486 658.897 351.816 577.424 362.001",
    stroke: "#E4E6EF",
    strokeWidth: 3.70335,
    strokeDasharray: "7.41 7.41"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M583.907 203.685H349.668L349.67 181.465L583.907 189.798L755.186 212.944V236.09L583.907 203.685Z",
    fill: "white"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 552.424,
    cy: 220.349,
    r: 24.0718,
    stroke: "#E4E6EF",
    strokeWidth: 3.70335
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M560.28 212.495L544.568 228.207",
    stroke: "#E4E6EF",
    strokeWidth: 3.70335,
    strokeLinecap: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M560.28 228.204L544.568 212.492",
    stroke: "#E4E6EF",
    strokeWidth: 3.70335,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1096_567",
    x: 326.52,
    y: 101.847,
    width: 451.808,
    height: 266.641,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.70335
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11.11
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.109804 0 0 0 0 0.137255 0 0 0 0 0.243137 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1096_567"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1096_567",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyState);
export default __webpack_public_path__ + "static/media/empty-state.81d86ae038bf1b61ec364d88531d6414.svg";
export { ForwardRef as ReactComponent };